module.exports = new __parcel__URL__("demo.e7d5e571.mp4").toString();